import { IBookingDetail } from 'pages/patientReceive/interfaces'
import { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router'
import { useReceiveServices } from 'services'

const useGetBookingDetail = () => {
  const { id } = useParams()
  const [loading, setLoading] = useState(false)
  const [bookingDetail, setBookingDetail] = useState<IBookingDetail>({})
  const { getDetailBooking } = useReceiveServices()
  const location = useLocation()
  useEffect(() => {
    if (!id) {
      setBookingDetail({})
      return
    }
    handleGetDetailBooking()
  }, [id])
  const handleGetDetailBooking = async () => {
    setLoading(true)
    if (
      id &&
      ![
        `/booking/patient/patient/${id}`,
        `/booking/booking/patient/${id}`,
        `/examination/patient/patient/${id}`
      ].includes(location.pathname)
    ) {
      return getDetailBooking(id)
        .then((res) => {
          if (res._successfully) {
            const booking = res?.data
            setBookingDetail(booking)
            return booking
          }
        })
        .finally(() => setLoading(false))
    }
  }

  const updateHeathRecordByAnotherBooking = async (bookingId: number) => {
    const res = await getDetailBooking(bookingId.toString())
    return res?.data?.health_record?.clinic_metadata
  }

  return {
    loading,
    bookingDetail,
    reloadBookingDetail: handleGetDetailBooking,
    setBookingDetail,
    updateHeathRecordByAnotherBooking
  }
}

export default useGetBookingDetail
